import { useEffect, useMemo, useState } from "react";
import { api } from "../api";
import type { CommuteHistoryResponse } from "../types";
import { today } from "../payrollPresentation";
import { commuteClock } from "../commuteHistoryPresentation";
import { Button } from "./ui/Button";
import { EmptyState, Feedback, TableFrame } from "./ui/Surface";
import "./CommuteHistory.css";

/* 출퇴근 = 정산·작업자 창과 같은 틀(2026-11-04 지윤): 제목 줄 오른쪽에 검색칸 하나, 그 아래 표.
   조회 월·작업자 고르개·새로고침은 걷었다 — 최근 93일(출퇴근 서버가 한 번에 주는 최대)을 받아 두고, 검색칸이 날짜·작업자를 함께 거른다.
   창을 열 때마다 새로 받으므로 새로고침 단추도 필요 없다. */
const DAY_MS = 86_400_000;

export function CommuteHistory() {
  const range = useMemo(() => {
    const to = today();
    return { from: new Date(Date.parse(`${to}T12:00:00Z`) - 92 * DAY_MS).toISOString().slice(0, 10), to };
  }, []);
  const [query, setQuery] = useState("");
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState<{ data?: CommuteHistoryResponse; error?: string }>({});
  useEffect(() => {
    const controller = new AbortController();
    setState({});
    void api.commuteHistory(range, controller.signal).then(data => {
      if (!controller.signal.aborted) setState({ data });
    }).catch(cause => {
      if (!controller.signal.aborted) setState({ error: cause instanceof Error ? cause.message : "출퇴근 기록을 불러오지 못했습니다." });
    });
    return () => controller.abort();
  }, [range, attempt]);
  const needle = query.trim().toLocaleLowerCase("ko-KR");
  const rows = state.data?.records.filter(row => !needle || `${row.date} ${row.workerName}`.toLocaleLowerCase("ko-KR").includes(needle)) ?? [];
  return <div className="commute-history" data-testid="commute-history">
    <label className="commute-head-search">
      <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>
      <input type="text" value={query} onChange={event => setQuery(event.target.value)} placeholder="검색" aria-label="출퇴근 찾기" />
    </label>
    {state.error ? <Feedback tone="error">{state.error} <Button onClick={() => setAttempt(value => value + 1)}>다시 시도</Button></Feedback>
      : !state.data ? <p role="status">출퇴근 기록을 불러오고 있습니다…</p>
      : !rows.length ? <EmptyState>{needle ? "검색 결과가 없습니다." : "최근 출퇴근 기록이 없습니다."}</EmptyState>
      : <TableFrame label="작업자별 날짜별 출퇴근 기록" className="commute-history-table">
        <thead><tr><th scope="col">날짜</th><th scope="col">작업자</th><th scope="col">출근</th><th scope="col">퇴근</th></tr></thead>
        <tbody>{rows.map(row => <tr key={`${row.date}:${row.workerName}`}>
          <td>{row.date}</td><td>{row.workerName}</td><td>{commuteClock(row.arrivalTime)}</td><td>{commuteClock(row.departureTime)}</td>
        </tr>)}</tbody>
      </TableFrame>}
  </div>;
}
